import { getGroupsContaining } from '@/apis/groups';
import {
  BACKEND_RECOVERY_POLL_MS,
  markBackendUp,
  type DomainCode,
} from '@australiangreens/ag-internal-components';

export const CIVI_RECOVERY_POLL_MS = BACKEND_RECOVERY_POLL_MS;

type StartCiviRecoveryPollingOptions = {
  getAccessToken: () => Promise<string>;
  domainCode: DomainCode;
  onRecovered?: () => void;
};

/**
 * While Civi is latched DOWN, periodically hit a cheap Civi-backed GET.
 * Success clears the Civi latch (hashz / unrelated successes cannot).
 */
export function startCiviRecoveryPolling({
  getAccessToken,
  domainCode,
  onRecovered,
}: StartCiviRecoveryPollingOptions): () => void {
  let cancelled = false;

  const probe = async () => {
    try {
      const token = await getAccessToken();
      await getGroupsContaining(token, 'a', domainCode);
      if (cancelled) return;
      markBackendUp({ clearCivi: true });
      onRecovered?.();
    } catch {
      // Civi still unreachable — keep polling.
    }
  };

  void probe();
  const intervalId = window.setInterval(probe, CIVI_RECOVERY_POLL_MS);
  return () => {
    cancelled = true;
    window.clearInterval(intervalId);
  };
}
